var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNumber2IconFpo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 75 75",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#number-2-icon-fpo_svg__clip0_1212_22756)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.5 75C58.21 75 75 58.21 75 37.5S58.21 0 37.5 0C16.789 0 0 16.79 0 37.5S16.789 75 37.5 75z",
  fill: "#F9A13A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5 66C53.24 66 66 53.24 66 37.5S53.24 9 37.5 9 9 21.76 9 37.5 21.76 66 37.5 66z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5 64.5c14.911 0 27-12.088 27-27s-12.089-27-27-27c-14.912 0-27 12.088-27 27s12.088 27 27 27z",
  stroke: "#29398C",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.72 52v-5.6l11.04-10c.693-.667 1.253-1.347 1.68-2.04.427-.693.64-1.467.64-2.32 0-1.013-.32-1.827-.96-2.44-.64-.64-1.493-.96-2.56-.96-1.12 0-2.04.4-2.76 1.2-.693.773-1.107 1.8-1.24 3.08l-6.44-.88c.16-1.44.547-2.72 1.16-3.84a9.931 9.931 0 012.4-2.84c.96-.8 2.053-1.4 3.28-1.8a12.205 12.205 0 013.96-.64c1.307 0 2.573.173 3.8.52 1.227.347 2.32.88 3.28 1.6.96.72 1.72 1.627 2.28 2.72.587 1.093.88 2.373.88 3.84 0 1.013-.133 1.933-.4 2.76a8.81 8.81 0 01-1.12 2.24 12.253 12.253 0 01-1.6 1.96c-.587.587-1.2 1.173-1.84 1.76l-6.56 5.84H49.2V52H28.72z",
  fill: "#29398C"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "number-2-icon-fpo_svg__clip0_1212_22756"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h75v75H0z"
})))));
export default __webpack_public_path__ + "static/number-2-icon-fpo.99fc3488394cd4e3273e1ae21b492349.svg";
export { SvgNumber2IconFpo as ReactComponent };